import { IdGenerator } from 'factories/lib/uuid';
import SearchFilter from 'models/search/search_filter';
import SearchQuery from 'models/search/search_query';
import SearchQueryConverter from 'scripts/application/dto_converters/search/search_query_converter';
import SnippetSearchResultConverter from 'scripts/application/dto_converters/search/snippet_search_result_converter';

export default function fetchSnippetsByIds(context, answerIds) {
  const id = IdGenerator.newId();
  const filter = new SearchFilter({ answerIds });
  const query = new SearchQuery({ filter, text: '', from: 0, size: answerIds.length });
  const queryDto = { query: SearchQueryConverter.toDto(query) };

  return context.gateways.answerSearch.request(queryDto).then(dto => {
    return SnippetSearchResultConverter.fromDto({ ...dto, id }).hits;
  });
}
